import SSWhiteText from "@core-components/title/components/SSWhiteText";
import NumberHelpers from "@helpers/NumberHelper";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Divider, Group, Text } from "@mantine/core";
import { useBasketStore } from "../stores/Basket.store";

const PriceDisplay: React.FC = () => {
  const { price, voucherInfo, affiliationCodeInfo, accounts } =
    useBasketStore();
  const { t } = useAppTranslation("pages.order.basket.priceDisplay");

  return (
    <div className="w-full font-inter text-primary-dark-text">
      <Divider />
      <div className="w-full space-y-5 py-5">
        <Group className="w-full justify-between">
          <Text>{t("price")}</Text>
          {NumberHelpers.priceFormatter(price.subTotal)}
        </Group>
        {voucherInfo.isFilled &&
          voucherInfo.isValid &&
          (price.discount ?? -1) > 0 && (
            <Group className="w-full justify-between">
              <Text>{t("discount")}</Text>
              {NumberHelpers.priceFormatter(-1 * (price.discount ?? 1))}
            </Group>
          )}
        {affiliationCodeInfo.isFilled && affiliationCodeInfo.isValid && (
          <Group className="w-full justify-between">
            <Text>{t("referralCode")}</Text>
            <Text>{affiliationCodeInfo.code}</Text>
          </Group>
        )}

        {(price.fees ?? -1) > 0 && (
          <Group className="w-full justify-between">
            <Text>{t("paypalFees")}</Text>
            {NumberHelpers.priceFormatter(price.fees)}
          </Group>
        )}
      </div>
      <Divider />
      <Group className="w-full justify-between pt-5 font-bold text-lg">
        <SSWhiteText>{t("total")}</SSWhiteText>
        <SSWhiteText>
          {NumberHelpers.priceFormatter(accounts.length <= 0 ? 0 : price.total)}
        </SSWhiteText>
      </Group>
    </div>
  );
};

export default PriceDisplay;
